// src/Login.js
import React, { useState } from "react";
import { auth, firestore, storage } from './firebase';
import { signInWithEmailAndPassword } from "firebase/auth";
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from "react-router-dom";
import "./Login.css";
import Veri from './assets/VerifiedTransaction.png';
import profileImag from './assets/grouperr.svg';
import EmailIcon from './assets/emailShape.svg'
import PassIcon from './assets/passwordIcon.svg';
import profileIma from './assets/google.svg';



const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [securityQuestions, setSecurityQuestions] = useState(['', '', '']);
  const [securityAnswers, setSecurityAnswers] = useState(['', '', '']);
  const [profileImage, setProfileImage] = useState(null);
  const [pin, setPin] = useState('');
  const [profileImageUrl, setProfileImageUrl] = useState('');
  const navigate = useNavigate();

  const provider = new GoogleAuthProvider();

  const closeModal = () => {
    setShowModal(false);
    setModalMessage('');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setModalMessage('Login successful!');
      setShowModal(true);
      navigate("/verify-pin");
    } catch (error) {
      console.error("Error during login:", error);
      setModalMessage('Login failed. Please check your email and password.');
      setShowModal(true);
    }
  };


  const handleGoogleSignup = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      console.log("Google sign-in result:", result);

      let profileImageUrl = user.photoURL || '';
      await setDoc(doc(firestore, 'users', user.uid), {
        username: user.displayName,
        email: user.email,
        securityQuestions,
        securityAnswers,
        pin,
        profileImageUrl,
        balance: 0,
        transactions: []
      });

      console.log("User document set in Firestore");

      setShowModal(true);
      setModalMessage('You have been successfully issued an account');
      navigate('/dashboard');
    } catch (error) {
      console.error("Error during Google signup:", error);
      setShowModal(true);
      setModalMessage(error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="image-uploadd">
        {/* <img src={profileImag} alt="Profile Preview" /> */}
        <div className='frontText'>
          <h2>Welcome back</h2>
          <p><span style={{color: '#0056b3'}}>UBS</span> will help you manage your finances in a simple way.</p>

          <button onClick={handleGoogleSignup} className='google-signup-button'><img src={profileIma} alt="Profile Preview" style={{width: 25, height: 25}} /> Signup with Google</button>

            <div style={{ color: '#00000050', width: '90%', margin: '3%', textAlign: 'center'}}>
            ------------------- Or --------------------
            </div>
        </div>

        
      </div>


      <form className="login-form" onSubmit={handleLogin}>
      <p style={{margin: 10, marginTop: 20, color: '#2a2a2a80'}} >Your Email</p>

        <div className="flexLogin">
          <img src={EmailIcon} alt="" />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        </div>
        <p style={{margin: 10, marginTop: 20, color: '#2a2a2a80'}}>Your Password</p>

        <div className="flexLogin">
          <img src={PassIcon} alt="" />
          <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        </div>
        
        <button className="input" type="submit">Login</button>
      </form>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            
            <p style={{ width: '90%' }}>{modalMessage}</p>
            <span className="close" onClick={closeModal}>Okay</span>
          </div>
        </div>
      )}

      <div className="stratight">
        <p className="pp">You don't have an account ?</p>
        <a className="llinkoo" href="/signup">Signup Here</a>
      </div>
    </div>
  );
};

export default Login;
